import styles from "../../object-passport.module.css";

import { Flex } from "antd";

import CopyLink from "../CopyLink";

import {
  formateISODateToStr,
  getFullName,
  formateISODateToDateTime,
} from "@/utils";

const Footer = ({ date, author, printBtn, config }) => {
  return (
    <div className={styles.footer}>
      <div className={styles.container}>
        <Flex justify="space-between" align="center" gap={24}>
          <Flex
            vertical
            gap={24}
            justify="space-between"
            style={{ flex: "0 1 50%" }}
          >
            <Flex gap={24}>
              <div className={styles.headerTitle}>
                Паспорт объекта
                <span className={styles.date}>{formateISODateToStr(date)}</span>
              </div>
              <Flex gap={16} align="center">
                {printBtn}

                <CopyLink />
              </Flex>
            </Flex>

            <div className={styles.logoWrap}>
              {config?.logo_path && (
                <img
                  src={config.logo_path}
                  width={32}
                  height={32}
                  alt=""
                  className={styles.logo}
                />
              )}
              <span className={styles.logoName}>
                {!config?.is_red_logo ? (
                  config?.system_name
                ) : (
                  <div className={styles.namePlaceholder}>
                    {config?.system_name}
                  </div>
                )}
              </span>
            </div>
          </Flex>

          <div style={{ flex: "0 1 50%" }}>
            <div style={{ color: " var(--color-gray-m)", marginBottom: 4 }}>
              Распечатал
            </div>
            <div style={{ marginBottom: 16 }}>
              {getFullName(
                author.lastname,
                author.firstname,
                author.patronymic
              )}
            </div>

            <div style={{ color: " var(--color-gray-m)", marginBottom: 4 }}>
              Дата создания паспорта:
            </div>
            <div>{formateISODateToDateTime(date)}</div>
          </div>
        </Flex>
      </div>
    </div>
  );
};
export default Footer;
